import React from 'react';
import TranslatedDropdown from 'shared/components/select_components/translated_dropdown';
import styled from 'styled-components';
import type { TimeZoneOption } from '../../types';

type Props = {
  selectedTimeZoneOption: TimeZoneOption;
  selectTimeZoneOption: (arg1: TimeZoneOption) => void;
  timeZones: Array<TimeZoneOption>;
};

export default function TimeZonePicker(props: Props) {
  const { timeZones, selectedTimeZoneOption, selectTimeZoneOption } = props;

  return (
    <DropdownContainer data-provides="time-zone-picker">
      <TranslatedDropdown
        // @ts-expect-error - TS2322 - Type '{ inputId: string; options: TimeZoneOption[]; value: TimeZoneOption; onChange: (option: any) => void; isSearchable: true; }' is not assignable to type 'IntrinsicAttributes & Props'.
        inputId="time_zone_picker"
        options={timeZones}
        value={selectedTimeZoneOption}
        // @ts-expect-error - TS7006 - Parameter 'option' implicitly has an 'any' type.
        onChange={(option) => {
          selectTimeZoneOption(option);
        }}
        isSearchable
      />
    </DropdownContainer>
  );
}

const DropdownContainer = styled.div`
  margin-left: 5%;
  width: 90%;
`;
